import axios from 'axios';

const timeout = parseInt(process.env.REACT_APP_API_TIMEOUT, 10) || 20000;

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: timeout,
    headers: {
        'Content-Type': 'application/json',
        'Tenant-UUID': process.env.REACT_APP_TENANT_UUID || 'default-tenant-uuid'
    }
});

// Interceptor para adicionar o token de autorização (se necessário no futuro)
api.interceptors.request.use(config => {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        // Aqui você pode adicionar tratamento de erro específico se necessário
        // Por enquanto, apenas repassa o erro
        return Promise.reject(error);
    }
);

export default api;

